import { render, staticRenderFns } from "./CommentOrder.vue?vue&type=template&id=28bf0882&"
import script from "./CommentOrder.vue?vue&type=script&lang=ts&"
export * from "./CommentOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports